// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetContactIdMappingsRequestModel from '../../model/get-contact-id-mappings-request-model';
import GetContactIdMappingsRequestDTO from '../dto/get-contact-id-mappings-request-dto';
import dtoSchema from '../schemas/get-contact-id-mappings-request-schema';

export default abstract class GetContactIdMappingsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetContactIdMappingsRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.foreignAppSystemIdCriteria = data.foreignAppSystemIdCriteria;
      this.crmStatusIdCriteria = data.crmStatusIdCriteria;
      this.mappingStatusIdCriteria = data.mappingStatusIdCriteria;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  foreignAppSystemIdCriteria?: number;
  /**
  * @type {int32}
  */
  crmStatusIdCriteria?: number;
  /**
  * @type {int32}
  */
  mappingStatusIdCriteria?: number;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO>): GetContactIdMappingsRequestModel;
  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO> | undefined | null): GetContactIdMappingsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetContactIdMappingsRequestDTO> | undefined | null): GetContactIdMappingsRequestModel | undefined {
    return dto ? new GetContactIdMappingsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetContactIdMappingsRequestModel> | GetContactIdMappingsRequestModel): GetContactIdMappingsRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      foreignAppSystemIdCriteria: unwrapped.foreignAppSystemIdCriteria,
      crmStatusIdCriteria: unwrapped.crmStatusIdCriteria,
      mappingStatusIdCriteria: unwrapped.mappingStatusIdCriteria,
      searchCriteria: unwrapped.searchCriteria,
    } as GetContactIdMappingsRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetContactIdMappingsRequestModel, can not map to GetContactIdMappingsRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
